import { render, staticRenderFns } from "./ScrollSpyList.vue?vue&type=template&id=8fe25d6a&scoped=true&"
import script from "./ScrollSpyList.vue?vue&type=script&lang=js&"
export * from "./ScrollSpyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe25d6a",
  null
  
)

export default component.exports